import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { ConfigService } from '../config/config.service';

const RESERVED_SUBDOMAINS = ['www', 'app', 'admin', 'api', 'staging', 'stage', 'sandbox', 'pre', 'dev'];

@Injectable({ providedIn: 'root' })
export class TenantIdService {
  private resolvedTenantId: string | null = null;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(DOCUMENT) private document: Document,
    private configService: ConfigService
  ) {}

  resolve(): string | null {
    if (this.resolvedTenantId) return this.resolvedTenantId;

    const configTenantId = this.configService.tenantId;
    if (configTenantId) {
      this.resolvedTenantId = configTenantId;
      return this.resolvedTenantId;
    }

    if (isPlatformBrowser(this.platformId)) {
      const hostname = this.document.location.hostname;
      const parts = hostname.split('.');

      if (parts.length >= 3) {
        const candidate = parts[0];
        if (!RESERVED_SUBDOMAINS.includes(candidate)) {
          this.resolvedTenantId = candidate;
          return this.resolvedTenantId;
        }
      }
    }

    return null;
  }

  getTenantId(): string | null {
    return this.resolvedTenantId ?? this.resolve();
  }
}
